import { render } from "./CardList.vue?vue&type=template&id=22049ea9&scoped=true"
import script from "./CardList.vue?vue&type=script&lang=js"
export * from "./CardList.vue?vue&type=script&lang=js"

import "./CardList.vue?vue&type=style&index=0&id=22049ea9&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\digital-gate\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22049ea9"]])

export default __exports__